"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownItems = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("@headlessui/react");
const constants_1 = require("../../constants");
const Items = (0, styled_1.default)(react_1.Menu.Items)(constants_1.dropdownItemsStyles);
const DropdownItems = (props) => {
    return ((0, jsx_runtime_1.jsx)(Items, { alignItems: props.alignItems, onBlur: props.onBlur, children: props.children }));
};
exports.DropdownItems = DropdownItems;
